import {React,useRef,useState} from 'react';
import ProductsOrderTable from '../MinComponents/ProductsOrderTable';
import { useEffect } from 'react';
import Loading from '../MinComponents/Loading';
import axios from 'axios';
import LargeModal from '../LargeModal';
const OrdersTab = () => {
  const [data,setData]=useState([]);
  const [isLoading,setLoading]=useState(true);
  useEffect(()=>{
    const url=`${process.env.REACT_APP_BASE}/admin/orders`;
      axios.get(url).then((res)=>{
        return res;
      }).then((data)=>{
        return(data.data.order);
      }).then((data)=>{
        let sampleData=[];
        data.map((item)=>{
          sampleData.push(item);
        })
        setData(sampleData);
        console.log(data);
        setLoading(false);
      }).catch((err)=>{
        alert("error occured, contact developer")
        setLoading(false);
      });
  },[])


  const [curr, setCurr]=useState(0);
  const [isModalActive, setModalActive]=useState(false);
  const [product,setProduct]=useState(null);


  const startModal=()=>{
    setModalActive(true);
  }
  const shutModal=()=>{
    setModalActive(false);
  }
  const addData=(item)=>{
    console.log("wow");
    setProduct(item);
    startModal();
  }
  return (
    
    <div className="bg-white p-8 rounded-md w-full">
      {
        isModalActive?<LargeModal product={product} close={shutModal}/>:null
      }
      <div className="-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto">
            {            
            isLoading?
            <Loading/>:
                data.length===0?
                <div>
                    No orders to show. Please Come Again Later
                </div>
                :
                <div className="inline-block min-w-full shadow rounded-lg overflow-hidden">
                <table className="min-w-full leading-normal">
                  <thead>
                    <tr>
                      <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        Name
                      </th>
                      <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        Shoe Name
                      </th>
                      <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        Created at
                      </th>
                      <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        AMOUNT
                      </th>
                      <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        Functions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* Sample Table Rows */}
                    {/* ... Fill in more table rows with actual data ... */}
                    
                  </tbody>
                  {data.slice(curr,curr+10).map((data,i)=>{
                    return <ProductsOrderTable item={data} key={i} setter={addData}/>
                  })}
                </table>
                <div className="px-5 py-5 bg-white border-t flex flex-col xs:flex-row items-center xs:justify-between">
                  <span className="text-xs xs:text-sm text-gray-900">
                    Showing {curr+1} of {data.length} Entries
                  </span>
                  <div className="inline-flex mt-2 xs:mt-0">
                    <button className="text-sm text-indigo-50 transition duration-150 hover:bg-indigo-500 bg-indigo-600 font-semibold py-2 px-4 rounded-l" onClick={()=>{if(curr-10<0)return; 
                    setCurr(curr-10); console.log("wow");}}>
                      Prev
                    </button>
                    &nbsp; &nbsp;
                    <button className="text-sm text-indigo-50 transition duration-150 hover:bg-indigo-500 bg-indigo-600 font-semibold py-2 px-4 rounded-r" onClick={()=>{if(curr+10>data.length)return;
                  setCurr(curr+10); console.log("wiw")}}>
                      Next
                    </button>
                  </div>
                </div>
              </div>
            }
              

      </div>
    </div>
  );
};

export default OrdersTab;
